export default "__VITE_ASSET____5SypJu__"